/*
 * Module for the Report Listing Index View
 */
rs.module("content/reports/index",

    [],

    function () {

        // Initialize the page
        function initialize(jsSelectors, cssClasses, backendUrls) {

            // Hook up favorite icon click handler 
            $(document).onjs("click", jsSelectors.favoriteIcon, _onFavoriteClick); 

            // Favorite icon click handler
            function _onFavoriteClick() {

                // call backend to save favorite report
                $.post(backendUrls.saveFavoriteReport, {
                    "templateid": $(this).data("templateid")
                });

                // toggle favorite icon css class
                $(this).toggleClass(cssClasses.favorite);
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);